// extracted by mini-css-extract-plugin
module.exports = {"scrollBarText":"Scrollbar-module--scrollBarText--3dbGX","anchorLinks":"Scrollbar-module--anchorLinks--3tk6O"};